import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { priceGetFormattedPrice } from '../../../../price'
import { useProductVolumePricingContext } from '../ProductVolumePricingContext'
import { ProductVolumePricingCompactDiscountBadge } from '../ProductVolumePricingDiscountBadges'

import { useGetDiscountRanges } from './useGetDiscountRanges'

export const ProductVolumePricingModalTable: FC = () => {
  const { volumeBasedPrices } = useProductVolumePricingContext()
  const ranges = useGetDiscountRanges(volumeBasedPrices)
  const intl = useIntl()

  return (
    <>
      <h1 className="mt-4 text-l font-medium">
        <FormattedMessage id="volumePricing.modal.heading" />
      </h1>
      <div className="mt-4 rounded-xl bg-light-primary-low pb-4">
        <table className="w-full">
          <tr>
            <th className="p-4 pb-2 text-left text-s font-medium text-dark-primary-max">
              <FormattedMessage id="volumePricing.modal.table.quantity.label" />
            </th>
            <th className="w-10 p-4 pb-2 pl-0 text-left text-s font-medium">
              <FormattedMessage id="volumePricing.modal.table.savingPrice.label" />
            </th>
            <th className="w-10 p-4 pb-2 pl-0 text-left text-s font-medium">
              <FormattedMessage id="volumePricing.modal.table.discount.label" />
            </th>
          </tr>
          <tbody>
            {ranges.map((discount, index, discounts) => (
              <tr key={discount.id}>
                <td className="pl-4 text-left text-s font-normal text-dark-primary-strong">
                  {discount.range}{' '}
                  <FormattedMessage
                    id="volumePricing.modal.table.pieces.label"
                    values={{ quantity: discount.range }}
                  />
                  {index === discounts.length - 1 && (
                    <>
                      {' '}
                      <FormattedMessage id="volumePricing.modal.table.morePieces.label" />
                    </>
                  )}
                </td>
                <td className="pr-4 text-s font-normal text-dark-primary-max">
                  <div>{priceGetFormattedPrice(discount.price, intl)}</div>
                </td>
                <td className="h-10">
                  {discount.price && discount.price > 0 ? (
                    <ProductVolumePricingCompactDiscountBadge
                      selectedValue={discount.rangeStart}
                    />
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}
